"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickSPT = void 0;
const findFilterByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findFilterByKey"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePositons_1 = require("@opsbase/react-gql-hooks/position/usePositons");
const useStaff_1 = require("@opsbase/react-gql-hooks/staff/useStaff");
const useTeams_1 = require("@opsbase/react-gql-hooks/team/useTeams");
const useDebouncedValue_1 = __importDefault(require("@opsbase/react-hooks/useDebouncedValue"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const SearchBox_1 = __importDefault(require("@opsbase/web-textfield/SearchBox"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const PickerItem_1 = __importDefault(require("@opsbase/web-ui/PickerItem"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    listItem: {
        cursor: 'pointer',
        borderLeft: '5px solid white',
        transition: 'background 0.3s, border 0.3s',
        '&:hover': {
            background: lib_palette_1.default.LightBlue.main,
            borderColor: lib_palette_1.default.secondary.main,
        },
    },
    menuFooter: {
        backgroundColor: lib_palette_1.default.secondary.main,
        color: lib_palette_1.default.White.main,
        padding: 8,
        fontSize: 12,
        textAlign: 'center',
    },
});
const maxToShow = 6;
function PickSPT(props) {
    const { queryField, filters, onSelect = doNothing_1.default } = props;
    const [hasSearch, setHasSearch] = (0, react_1.useState)(false);
    const [keyword, setKeyword] = (0, react_1.useState)('');
    const decouncedKeyword = (0, useDebouncedValue_1.default)(keyword, 500);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const { loading: lStaff, data: dStaff } = (0, useStaff_1.useStaffCollection)({
        variables: { keyword: decouncedKeyword },
    });
    const { loading: lPosition, data: dPosition } = (0, usePositons_1.usePositionsCollection)({
        variables: { keyword: decouncedKeyword },
    });
    const { loading: lTeam, data: dTeam } = (0, useTeams_1.useTeamsCollection)({
        variables: { keyword: decouncedKeyword },
    });
    const loading = lStaff || lPosition || lTeam;
    const items = [...((dStaff === null || dStaff === void 0 ? void 0 : dStaff.items) || []), ...((dPosition === null || dPosition === void 0 ? void 0 : dPosition.items) || []), ...((dTeam === null || dTeam === void 0 ? void 0 : dTeam.items) || [])];
    const totalCount = ((dStaff === null || dStaff === void 0 ? void 0 : dStaff.totalCount) || 0) + ((dPosition === null || dPosition === void 0 ? void 0 : dPosition.totalCount) || 0) + ((dTeam === null || dTeam === void 0 ? void 0 : dTeam.totalCount) || 0);
    (0, react_1.useEffect)(() => {
        if (!loading)
            setHasSearch(hasSearch || totalCount > maxToShow);
    }, [loading, totalCount, hasSearch]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hasSearch && react_1.default.createElement(SearchBox_1.default, { autoFocus: true, keyword: keyword, onChange: setKeyword }),
        loading && react_1.default.createElement(Dots_1.default, { style: { margin: '16px auto' }, color: lib_palette_1.default.primary }),
        !loading &&
            items.slice(0, maxToShow).map(item => {
                const isSelected = !!(0, findFilterByKey_1.default)(filters, queryField.key, item.id);
                return (react_1.default.createElement(PickerItem_1.default, { key: item.id, type: item.__typename, title: item.title, selected: isSelected, highlight: keyword, onClick: e => onSelect({
                        queryFieldKey: queryField.key,
                        id: item === null || item === void 0 ? void 0 : item.id,
                        title: item === null || item === void 0 ? void 0 : item.title,
                    }, e), className: myCss.listItem }));
            }),
        totalCount > maxToShow && (react_1.default.createElement("div", { className: myCss.menuFooter }, lib_i18n_1.default.t('showing-x-of-y', { x: maxToShow, y: totalCount })))));
}
exports.PickSPT = PickSPT;
exports.default = PickSPT;
